import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { action_global_get_init_message } from '../../../../../store/actions/pages/policy'
import { useSelector } from 'react-redux'
import { useMemo } from 'react'
import Header from "../../fragments/heading/index";
import { useIntl } from 'react-intl'
import { Iconfont } from '../../../../components/icon/iconfont'

const VipPolicy = props => {
    useStyles(classes)
    const pagePolicy = useSelector(state=>state.pagePolicy);
    const global = useSelector(state=>state.global);
    const { config } = global;
    const intl = useIntl();

    const messageData = useMemo(() =>{
        if(pagePolicy?.vipPolicy?.message){
            let message = pagePolicy?.vipPolicy?.message;
            message = message.replace(/#siteLabel/g, config?.name);
            message = message.replace(/#siteDomain/g, config?.domain);
            return message;
        }else{
            return null;
        }
    },[pagePolicy?.vipPolicy?.message]);

  
    return <React.Fragment>
        {
            messageData && <React.Fragment>
                <Header 
                    centerSlot={`${config?.name} ${intl.formatMessage({id: 'policy', defaultMessage:'Policy'})}`} 
                    rightSlot={
                        <a href={'/cart'} className={classes.HeaderCart}>
                            <Iconfont className={classes.bigger}>&#xe6a4;</Iconfont>
                            {
                                global.countCart > 0 && <span className={classes.Num}>{global.countCart}</span>
                            }
                        </a>
                    }
                />

                <div className={classes.Container} dangerouslySetInnerHTML={{ __html: messageData }}></div>
            </React.Fragment>
        }
    </React.Fragment>
}

VipPolicy.fetchData = async (store, params, search, headers) => {
    await store.dispatch(action_global_get_init_message("M1659", "vipPolicy", headers))
}

export default VipPolicy
